import { c as _c } from "react/compiler-runtime";
import MUISnackbar, { SnackbarProps as MUISnackbarProps } from '@mui/material/Snackbar';
import { styled } from '../styles';
type SnackbarPropType = 'default' | 'success' | 'info' | 'error' | 'warning';
export interface Props extends Pick<MUISnackbarProps, 'children' | 'onClose' | 'action' | 'message' | 'autoHideDuration'> {
  isOpen: boolean;
  type?: SnackbarPropType;
}
const SnackbarStyled = styled(MUISnackbar, {
  shouldForwardProp: prop => !['type'].includes(prop as string)
})<{
  type: SnackbarPropType;
}>(({
  theme: {
    palette
  },
  type
}) => ({
  '.MuiSnackbarContent-root': {
    minWidth: '44px',
    maxWidth: '720px',
    /* istanbul ignore next */
    backgroundColor: {
      success: palette.notification.valid.main,
      info: palette.notification.info.main,
      error: palette.notification.error.main,
      default: palette.notification.neutral.main,
      warning: palette.notification.warning.main
    }[type]
  }
}));
const Snackbar = t0 => {
  const $ = _c(11);
  let isOpen;
  let otherProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isOpen,
      type: t1,
      autoHideDuration: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = isOpen;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
  } else {
    isOpen = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const type = t1 === undefined ? "default" : t1;
  const autoHideDuration = t2 === undefined ? 7000 : t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      vertical: "bottom",
      horizontal: "left"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== autoHideDuration || $[7] !== isOpen || $[8] !== otherProps || $[9] !== type) {
    t4 = <SnackbarStyled anchorOrigin={t3} open={isOpen} autoHideDuration={autoHideDuration} type={type} {...otherProps} />;
    $[6] = autoHideDuration;
    $[7] = isOpen;
    $[8] = otherProps;
    $[9] = type;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default Snackbar;